import { color } from '@upstox/upstox-ui';

export const sanitizedHTML: CSSFunction = ({ theme }) => ({
  color: color(theme, theme.colors.text[2]),
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '-0.09px',
  fontWeight: '500',

  '*': {
    all: 'revert',
  },

  '& ul,ol': {
    margin: '0px 8px',
    padding: '0px 8px',
    listStyleType: 'disc',
  },
  '& li:not(:last-child)': {
    marginBottom: '8px',
  },
});
